<template>
  <CommonPages class="rankings" headerTheme="dark" titlePrefix="Rank">
    <div class="rankings__banner-wrapper">
      <div class="rankings__banner-content">
        <div class="rankings__banner-title">
          <img src="@/assets/rank-wing.png" class="rankings__wing" alt="">
          <!-- <h1 class="rankings__banner-text">RANKINGS</h1>
          <img src="@/assets/rank-wing-r.svg" class="rankings__wing" alt=""> -->
        </div>

        <!-- Tab 切换器 -->
        <div class="rankings__tabs-container">
          <div class="rankings__tabs">
            <div class="rankings__tab" :class="{'rankings__tab--active': activeTab === 'release'}"
              @click="activeTab = 'release'">
              New Release Cars
            </div>
            <div class="rankings__tab" :class="{'rankings__tab--active': activeTab === 'fastest'}"
              @click="activeTab = 'fastest'">
              Top Fastest Cars
            </div>
          </div>
          <div class="rankings__tabs-line"></div>
        </div>
      </div>
    </div>

    <div class="rankings__container">
      <!-- 列表网格 -->
      <div class="rankings__grid" :class="{'rankings__grid--release': activeTab === 'release'}">
        <div v-for="(car, index) in currentCars" :key="`rank-row-${index}`" class="rankings__card-item">
          <a class="rankings__card"
            @click="gotoDetail(car)">

            <!-- 公用图片和Logo -->
            <div class="rankings__card-img-wrapper">
              <img :src="car.image" class="rankings__card-img" :alt="car.model">
              <div class="rankings__card-logo-box">
                <img :src="car.logo" class="rankings__card-logo">
              </div>
              <div v-if="activeTab === 'release'" class="rankings__release-badge">
                <img src="@/assets/calendar.svg" alt="">
                <span>{{ car.releaseTime }}</span>
              </div>
            </div>

            <!-- New Release 样式内容 (图一) -->
            <div v-if="activeTab === 'release'" class="rankings__card-content-release">
              <div class="rankings__card-info">
                <h3 class="rankings__card-title">{{ car.model }}</h3>
                <p class="rankings__card-brand">{{ car.brand }}</p>
              </div>
              <div class="rankings__tag-list">
                <div class="rankings__tag"><img
                    src="@/assets/car-type.svg"><span>{{ car.bodyType }}</span></div>
                <div class="rankings__tag"><img
                    src="@/assets/body-type.svg"><span>{{ car.category }}</span></div>
                <div class="rankings__tag"><img
                    src="@/assets/homehero/Budget.svg"><span>{{ car.price }}</span></div>
              </div>
            </div>

            <!-- Top Fastest 样式内容 (图二) -->
            <div v-else class="rankings__card-content-fastest">
              <div class="rankings__card-info">
                <p class="rankings__card-brand">{{ car.brand }}</p>
                <h3 class="rankings__card-title">{{ car.model }}</h3>
              </div>
              <div class="rankings__speed-badge">
                <span class="rankings__speed-val">{{ car.speedValue }}</span>
                <span class="rankings__speed-label">0-60-MPH</span>
              </div>
            </div>
          </a>

          <AdComponent v-if="shouldInsertRankInlineAd(index)"
            class="rankings__ad-inline" :ref="'ads-rank-inline-' + index"
            :ads="getRankInlineAdConfig(index)" :showDebug="showDebug" />
        </div>
      </div>

      <!-- 加载更多 -->
      <div v-if="(activeTab === 'release' ? releaseHasMore : fastHasMore)"
        class="rankings__load-more" @click="loadMore">
        <span>Load More</span>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import AdComponent from '@/pages/components/AdComponent.vue'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'

export default {
  name: 'Rankings',
  mixins: [adMixin, adTrackingMixin],
  components: {
    CommonPages,
    AdComponent
  },
  data () {
    return {
      activeTab: 'release',
      releaseRankCars: [],
      fastestRankCars: [],
      releasePageNum: 1,
      fastPageNum: 1,
      pageSize: 12,
      releaseHasMore: true,
      fastHasMore: true
    }
  },
  computed: {
    ...mapGetters(['deviceType', 'domainConfig', 'adsensConfig', 'showDebug']),
    currentCars () { return this.activeTab === 'release' ? this.releaseRankCars : this.fastestRankCars; }
  },
  mounted () {
    this.fetchReleaseRank();
    this.fetchFastRank();
  },
  methods: {
    getRankInlineAdConfig (index) {
      if (this.deviceType === 'mobile' && index === 0) {
        const config = this.adsensConfig?.rank_1;
        return this.$global.isValidAdConfig(config) ? config : null;
      }
      if (this.deviceType !== 'mobile' && index === 3) {
        const config = this.adsensConfig?.rank_1;
        return this.$global.isValidAdConfig(config) ? config : null;
      }
      if (this.deviceType === 'mobile' && index === 2) {
        const config = this.adsensConfig?.rank_2;
        return this.$global.isValidAdConfig(config) ? config : null;
      }
      if (this.deviceType === 'mobile' && index === 4) {
        const config = this.adsensConfig?.rank_3;
        return this.$global.isValidAdConfig(config) ? config : null;
      }
      return null;
    },
    shouldInsertRankInlineAd (index) {
      return !!this.getRankInlineAdConfig(index);
    },
    async fetchReleaseRank () {
      try {
        const themeFilters = this.domainConfig?.themeFilters || {};
        const res = await this.$global.server.releaseRank({ pageNum: this.releasePageNum, pageSize: this.pageSize, webIndex: this.domainConfig?.webIndex || 1, ...themeFilters });
        if (res.code === 200) {
          const processed = (res.data || []).map(item => this.formatCarData(item));
          this.releaseRankCars = [...this.releaseRankCars, ...processed];
          this.releaseHasMore = res.data.length >= this.pageSize;
          this.releasePageNum++;
        }
      } catch (e) { console.error(e); }
    },
    async fetchFastRank () {
      try {
        const themeFilters = this.domainConfig?.themeFilters || {};
        const res = await this.$global.server.fastRank({ pageNum: this.fastPageNum, pageSize: this.pageSize, webIndex: this.domainConfig?.webIndex || 1, ...themeFilters });
        if (res.code === 200) {
          const processed = (res.data || []).map(item => this.formatCarData(item));
          this.fastestRankCars = [...this.fastestRankCars, ...processed];
          this.fastHasMore = res.data.length >= this.pageSize;
          this.fastPageNum++;
        }
      } catch (e) { console.error(e); }
    },
    formatCarData (item) {
      const photos = item.photos ? item.photos.split(',') : [];
      let releaseTime = item.marketTime || item.year || '-';
      if (releaseTime && releaseTime.length >= 7) releaseTime = releaseTime.substring(0, 7).replace('-', '.');
      return {
        ...item,
        logo: item.logoUrl,
        image: item.cover || photos[0],
        model: item.name,
        releaseTime: releaseTime,
        year: item.year || item.marketTime?.substring(0, 4) || '-',
        speedValue: item.accelerationTime ? `${item.accelerationTime}s` : '-',
        bodyType: item.type || '-',
        category: item.purpose || '-',
        price: this.formatPrice(item.leastPrice, item.mostPrice) || '-'
      };
    },
    formatPrice (least, most) {
      if (!least && !most) return null;
      const fmt = (n) => n ? '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
      if (least && most) return `${fmt(least)}-${fmt(most)}`;
      return least ? `>${fmt(least)}` : `<${fmt(most)}`;
    },
    loadMore () { this.activeTab === 'release' ? this.fetchReleaseRank() : this.fetchFastRank(); },
    gotoDetail (car) {
      const channel = this.$route.params.channel;
      const name = encodeURIComponent(car.model.replace(/\s+/g, '-'));
      const path = channel ? `/${channel}/cars/${name}/${car.id}` : `/cars/${name}/${car.id}`;
      this.$router.push(path);
    },
    gotoAll () { this.$router.push('/car-list'); }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.rankings {
	background: #000 url('../assets/rank-bg-pc.png') no-repeat;
	background-size: 100%;
	background-position: 0 rem(80);
	min-height: 100vh;

	&__banner-wrapper {
		padding: rem(40) 0 rem(40);
		display: flex;
		justify-content: center;
	}

	&__card-item {
		display: contents;
	}

	&__banner-content {
		width: 100%;
		max-width: rem(1440);
		padding: 0 rem(180);
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: rem(40);
	}

	&__banner-title {
		display: flex;
		align-items: center;
		gap: rem(20);
	}

	&__banner-text {
		color: #ffffff;
		font-family: 'Inter-Black', sans-serif;
		font-size: rem(48);
		font-weight: 900;
		margin: 0;
	}

	&__wing {
		height: rem(40);
	}

	&__tabs-container {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	&__tabs {
		display: flex;
		gap: rem(4);
	}

	&__tab {
		padding: rem(10) rem(24);
		background: rgba(255, 255, 255, 0.1);
		box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.24);
		border-radius: rem(12) rem(12) 0 0;
		color: #ffffff;
		font-family: 'Inter-SemiBold', sans-serif;
		font-size: rem(14);
		cursor: pointer;
		transition: all 0.3s ease;

		&--active {
			background: #e2372d;
			font-weight: 800;
		}
	}

	&__tabs-line {
		width: 100%;
		height: 2px;
		background: #e2372d;
	}

	&__container {
		padding: 0 rem(180) rem(40);
		width: 100%;
		box-sizing: border-box;
	}

	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(40);
	}

	&__title {
		color: #fff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(24);
		font-weight: 800;
		margin: 0;
	}

	&__view-more {
		display: flex;
		align-items: center;
		gap: rem(12);
		text-decoration: none;
		span {
			color: #e2372d;
			font-family: 'Inter-ExtraBold', sans-serif;
			font-size: rem(14);
			font-weight: 800;
		}
	}

	&__grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: rem(30);

		&--release {
			grid-template-columns: repeat(4, 1fr);
		}
	}

	&__card {
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		display: flex;
		flex-direction: column;
		overflow: hidden;
		transition: all 0.3s ease;
		text-decoration: none;
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);

		&:hover {
			transform: translateY(-5px);
			border-color: rgba(226, 55, 45, 0.5);
		}
	}

	&__card-img-wrapper {
		position: relative;
		height: rem(180);
		padding: rem(8);
	}

	&__card-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(12);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}

	&__card-logo-box {
		position: absolute;
		top: rem(8);
		left: rem(8);
		width: rem(32);
		height: rem(32);
		background: #fff;
		border-radius: rem(12) 0 rem(12) 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: rem(4);
	}

	&__card-logo {
		width: 80%;
		height: 80%;
		object-fit: contain;
	}

	&__release-badge {
		position: absolute;
		top: rem(8);
		left: rem(40);
		background: #e2372d;
		border-radius: 0 0 rem(12) 0;
		padding: rem(4) rem(8);
		display: flex;
		align-items: center;
		gap: rem(4);
		img {
			width: rem(12);
			height: rem(12);
			filter: brightness(0) invert(1);
		}
		span {
			color: #fff;
			font-size: rem(12);
		}
	}

	&__card-content-release {
		padding: rem(12) rem(16) rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(12);
	}

	&__tag-list {
		display: flex;
		flex-direction: column;
		gap: rem(6);
	}

	&__tag {
		background: rgba(255, 255, 255, 0.05);
		border-radius: rem(12);
		padding: rem(10) rem(16);
		display: flex;
		align-items: center;
		gap: rem(12);
		img {
			width: rem(16);
			height: rem(16);
			// filter: brightness(0) invert(1);
		}
		span {
			color: #fff;
			font-size: rem(12);
		}
	}

	&__card-content-fastest {
		padding: rem(4) rem(20) rem(12);
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__card-title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(16);
		font-weight: 800;
		margin: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__card-brand {
		color: rgba(255, 255, 255, 0.5);
		font-size: rem(12);
		margin: 0;
	}

	&__speed-badge {
		padding: rem(6) rem(12);
		display: flex;
		flex-direction: column;
		align-items: center;

		border-radius: rem(12);
		border: 1px solid rgba(255, 255, 255, 0.1);
		background: linear-gradient(180deg, #e2372d 0%, rgba(226, 55, 45, 0) 100%);
		border-bottom: none;
	}

	&__speed-val {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(16);
		font-weight: 800;
	}

	&__speed-label {
		color: rgba(255, 255, 255, 0.7);
		font-size: rem(8);
	}

	&__load-more {
		margin-top: rem(40);
		text-align: center;
		cursor: pointer;
		color: #e2372d;
		font-weight: 700;
		font-size: rem(16);
	}

	&__ad-inline {
		grid-column: 1 / -1;
		width: 100%;
	}
}

.rank-top-ad-padding {
	padding: 0 rem(180);
	box-sizing: border-box;
}

.detect_deviece_mobile {
	.rank-top-ad-padding {
		padding: 0 rem(16);
	}
	.rankings {
		overflow-x: hidden;
	}
	.rankings__ad-inline {
		padding-right: rem(16);
		box-sizing: border-box;
	}
	.rankings__banner-content {
		padding: 0 rem(20);
	}
	.rankings__container {
		padding: 0 rem(16) rem(40);
	}
	.rankings__grid {
		grid-template-columns: 1fr;
	}
	.rankings__card {
		width: 100%;
		min-width: 0;
	}
	.rankings__card-img-wrapper {
		width: 100%;
		box-sizing: border-box;
	}
	.rankings__card-content-release,
	.rankings__card-content-fastest,
	.rankings__card-info {
		min-width: 0;
	}
	.rankings__tabs {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
	.rankings__tab {
		min-width: 0;
		padding: rem(10) rem(8);
		text-align: center;
	}
}
</style>
